import * as React from 'react';
import { useSelector } from 'react-redux';
import {
  selectDisablePromotionSection,
  selectIsUnavailableImportOfferPromotionForSelfMoneySource,
} from '../../../../selectors/publishTerms';
import { ServicesLayout } from './components/ServicesLayout';
import { ServiceErrorContainer } from './components/ServiceError';
import { TermsDurationsContainer } from './components/TermsDurations';
import { ImportOfferPromotionUnavailable } from './components/ImportOfferPromotionUnavailable';
import { ServicesContainer } from './components/Services';
import { Competitors } from './components/Competitors';
import { useCompetitors } from './components/Competitors/hooks';
import { selectTermsDurations } from '../../../../reducers/v2/promotion/selectors';

export const PromotionSectionContainer = () => {
  const isTermsDurationsAvailable = useSelector(selectTermsDurations).length > 0;

  const isImportOfferPromotionForSelfMoneySourceUnavailable = useSelector(
    selectIsUnavailableImportOfferPromotionForSelfMoneySource,
  );

  const allowDisablePromotionSection = useSelector(selectDisablePromotionSection);

  const competitors = useCompetitors();

  if (isImportOfferPromotionForSelfMoneySourceUnavailable) {
    return <ImportOfferPromotionUnavailable />;
  }

  return (
    <>
      <ServicesLayout
        services={<ServicesContainer />}
        error={<ServiceErrorContainer />}
        competitors={<Competitors level={competitors.level} promotions={competitors.promotions} />}
      />

      {isTermsDurationsAvailable && !allowDisablePromotionSection && <TermsDurationsContainer />}
    </>
  );
};
